/**
 * Ticketmaster Catalog "deactivate" sets e_status to offsale (and sometimes deactivated).
 * Add Tickets must hide those events for every role (admin, marketing/sales rep, affiliate admin).
 */
const BLOCKED = new Set([
  "closed",
  "postponed",
  "cancelled",
  "canceled",
  "unnecessary",
  "offsale",
  "off-sale",
  "deactivated",
  "deactive",
]);

export function isEventEligibleForAddTickets(event: {
  e_status?: string | null;
  e_is_active?: boolean | null;
}): boolean {
  const normalized = String(event?.e_status ?? "")
    .toLowerCase()
    .trim();
  const isActive = event?.e_is_active !== false;
  return isActive && !BLOCKED.has(normalized);
}
